import { mmss } from "../format";

/**
 * Figma B2 booking band: lilac 44 px, radius 10, inset 15 px in the sheet (the sheet pads 20 px),
 * clock 22 px at 14 px, "Réservé pour vous" Medium 15 and the mm:ss countdown SemiBold 20, violet.
 */
export function BookingBand(props: { remainingSec: number }) {
  return (
    <div
      class="-mx-[5px] h-[44px] rounded-[10px] bg-surface2 pl-[14px] pr-[15px] flex items-center text-violet"
      role="timer"
      aria-label={`Réservé pour vous, ${mmss(props.remainingSec)} restantes`}
    >
      <img src="/icons/clock.svg" width="22" height="22" alt="" />
      <span class="ml-[9px] text-[15px] font-medium leading-[1.25] tracking-[0.15px]">
        Réservé pour vous
      </span>
      <span class="ml-auto text-[20px] font-semibold leading-[1.25] tracking-[0.2px] tabular-nums">
        {mmss(props.remainingSec)}
      </span>
    </div>
  );
}
